export const titleClass = 'text-orange'
export const subTitleClass = 'text-orange'
export const description = ''

export const universalLeftRight = 'p-10 laptop:p-12 laptop-large:p-20'
export const breadCrumPadding = 'p-10 laptop:p-12 laptop-large:p-20'

export const resorcesClass = 'grid grid-cols-1 mobile:grid-cols-2 laptop:grid-cols-4 laptop-large:grid-cols-5 gap-4 laptop:gap-4 laptop-large:gap-10'

export const resourseItemClass = 'h-[75%]'
// export const investermenu = 'h-16 bg-red-100 rounded-xl px-3 py-2 hover:bg-orange cursor-pointer hover:font-bold hover:text-white laptop:text-red-500 '
export const investermenu = "laptop-large:h-16 bg-red-100 rounded-xl px-3 py-2 hover:bg-orange cursor-pointer hover:font-bold hover:text-white laptop:h-12 laptop:text-sm laptop:px-2 laptop:py-1"
